import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { GatewayService } from 'src/app/gateway.service';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-cliente-duplicado',
  templateUrl: './cliente-duplicado.component.html',
  styleUrls: ['./cliente-duplicado.component.scss']
})
export class ClienteDuplicadoComponent implements OnInit {
  private destroy$ = new Subject<void>();

  campanaColumns: string[] = ['NOMBRE', 'TELEFONO', 'CAMPANA_ORIGEN', "CAMPANA_DUPLICADA", 'DISTRIBUIDOR'];
  dataSource = new MatTableDataSource<any>([]);
  private subscription: Subscription;
  private subscriptioncreate: Subscription;
  private subscriptionpais: Subscription;
  FILTER; resultsLength = 0;
  pageSize = 10;
  idpais;
  pageEvent: PageEvent;
  public actpage: number = 0;

  @ViewChild('paginatordistribuidor') paginatordistribuidor: MatPaginator;

  constructor(
    private snackbar: MatSnackBar,
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _appservice: AppServiceService,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    private dialog: MatDialog,
    public _filtroPais: FiltroPaisService,
    private localSave: LocalSaveService
  ) { }

  ngOnInit() {
    this.idpais = this.localSave.get('pais');
    this.get(0);
    this.pageTitle.title = this.localSave.get('usuarioPGV').esDistribuidor ? 'Clientes no Aptos' : 'Clientes Duplicados';
    // this.loadUsuarios();
    this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.filtrardistribuidor(res.filtro);
      });
    this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.createTipologia();
      });
    this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.idpais = res.IDPAIS;
        this.get(0);
      }
    );
  }

  // ============== FILTRO ==============
  filter = '';
  public keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.filtrogeneral();
    } else if (event.keyCode == 8 && this.filter == '') {
      this.filtrogeneral();
    }
  }
  public filtrogeneral() {
    this._busqueda.notificarBusqueda({ filtro: this.filter });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription.unsubscribe();
    this.subscriptioncreate.unsubscribe();
    this.subscriptionpais.unsubscribe();
  }

  cambioElementos(event?: PageEvent) {
    this.actpage = event.pageIndex;
    this.get(event.pageIndex);
  }

  get(page) {
    this.spinner.show();
    if (page == 0) {
      this.paginatordistribuidor.firstPage();
    }
    this.gateway.get('pagineoclienteinvalido', { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').esDistribuidor ? this.localSave.get('usuarioPGV').IDU : null }).then((result) => {
      //console.log(result);
      let aux: any = result;
      this.dataSource = aux.rows;
      //this.resultsLength = result[1][0].TOTAL;
      this.gateway.get('conteoclienteinvalido', { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').esDistribuidor ? this.localSave.get('usuarioPGV').IDU : null }).then((result: any) => {
        //console.log(result.rows);
        this.resultsLength = result.rows[0].total;
        this.spinner.hide();
      });
    }
    ).catch(function (e) {
    });
  }

  createTipologia() {
    // const dialogRef = this.dialog.open(CreateDistribuidorComponent, {
    //   maxWidth: '90vw',
    //   width: '620px',
    //   minHeight: '40vh',
    //   data: { operacion: 'Crear', distribuidor: { IDPAIS: this.idpais } },
    //   disableClose: true
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   this.get(this.actpage);
    // });
  }

  filtrardistribuidor(data) {
    this.FILTER = data;
    this.get(0)
  }

  edit(element) {
    // element.IDPAIS = this.idpais;
    // const dialogRef = this.dialog.open(CreateDistribuidorComponent, {
    //   maxWidth: '90vw',
    //   width: '620px',
    //   minHeight: '40vh',
    //   data: { operacion: 'Editar', distribuidor: element },
    //   disableClose: true
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.get(this.actpage);
    //   }
    // });
  }

  delete(element) {
    this.gateway.get('setestadodistribuidor', { IDDISTRIBUIDOR: element.iddistribuidor, ESTADO: element.estado }).then((result) => {
      this.get(this.actpage);
    }
    ).catch(function (e) {
    });
  }

  exportar() {
    let page = 0;
    this.spinner.show();
    this.gateway.get('conteoclienteinvalido', { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').esDistribuidor ? this.localSave.get('usuarioPGV').IDU : null }).then(
      (data: any) => {
        if (data.rows[0].total > 0) {
          this.prepararinformacion(this.localSave.get('campana'), data.rows[0].total, 0, null);
        } else {
          this.snackbar.open('No hay registros de clientes duplicados.', 'Cerrar', { duration: 3000, });
          this.spinner.hide();
        }
      }
    );
  }

  prepararinformacion(campana, count, index, data) {
		// console.log('==========')
		// console.log({ IDCAMPANA: campana, LIMIT: 500, OFFSET: index })
		// console.log('==========')
		this.gateway.get('lotepagineoclienteinvalido', {NUM_PAGINA: 0, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').esDistribuidor ? this.localSave.get('usuarioPGV').IDU : null, IDCAMPANA: campana, LIMIT: 500, OFFSET: index }).then(
			(result: any) => {
				if (data) {
					data = data.concat(result.rows)
				} else {
					data = result.rows;
				}
				// console.log('==========')
				// console.log(data)
				// console.log('==========')
				let control = index + 500;
				if (control <= count) {
					// console.log('==========')
					// console.log(control)
					// console.log('==========')
					this.prepararinformacion(campana, count, control, data);
				} else {

					this.descargarexcel(data, campana);
				}
			}
		);
	}

  descargarexcel(ctr, campana) {
		const fileName = 'Clientes_Duplicados' + '-' + Date.now();
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(ctr);
		XLSX.utils.book_append_sheet(wb, ws);

		const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
		saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
		this.spinner.hide();
	}

}
